import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"

const ListLink = props => (
  <li className={`menu-item ${props.children.toLowerCase()}`}>
    <Link to={props.to}>{props.children}</Link>
  </li>
)

const Layout = ({ children }) => {
  const data = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
          }
        }
      }
    `
  )

  // Ensure the title is available and transform it safely
  const siteTitle = data.site?.siteMetadata?.title
    ? data.site.siteMetadata.title.toLowerCase().replace(/\s+/g, '-')
    : ''

  return (
    <main className={` ${siteTitle}`}>
      <header>
        <ul>
          <ListLink to="/wam1f24/">☻</ListLink>
          <ListLink to="/wam1f24/project/">Projects and Exercises</ListLink>
          <ListLink to="/wam1f24/readings/">Readings</ListLink>
          <ListLink to="/wam1f24/meeting/">Meeting</ListLink> 
          <ListLink to="/wam1f24/resource/">Resource</ListLink> 
          <ul className="menu-right">
            <ListLink to="/wam1f24/topics/">Topics</ListLink>
            <ListLink to="/wam1f24/syllabus/">Syllabus</ListLink>
            {/* <ListLink to="/wam1f24/colophon/" className="colophon">Colophon</ListLink> */}
          </ul>
        </ul>
      </header>
      {children}
    </main>
  )
}

export default Layout
